import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { ICard } from '../_shared/models/card/card.model';
import type { IFeaturedResources } from '../_shared/models/card/featured-resources.model';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { withConfigFallback } from '../_shared/utils/with-config-fallback';
import { CardGridComponent } from '../card/card-collection/card-grid/card-grid.component';
import { ContainerComponent } from '../container/container.component';
import { HeadingComponent } from '../heading/heading.component';

let _featuredResourcesUid = 0;

@Component({
    selector: 'sirius-featured-resources',
    templateUrl: './featured-resources.component.html',
    styleUrls: ['./featured-resources.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CardGridComponent, ContainerComponent, HeadingComponent],
    host: {
        '[attr.role]': 'resolvedTitle() ? "region" : null',
        '[attr.aria-labelledby]': 'resolvedTitle() ? titleId : null',
    },
})
export class FeaturedResourcesComponent implements IDynamicElement<IFeaturedResources> {
    readonly config = input<IFeaturedResources | undefined>(undefined);

    readonly title = input('');
    readonly items = input<ICard[]>([]);

    protected readonly resolvedTitle = withConfigFallback<IFeaturedResources, 'title', string>(
        this.config,
        'title',
        this.title
    );
    protected readonly resolvedItems = withConfigFallback<IFeaturedResources, 'items', ICard[]>(
        this.config,
        'items',
        this.items
    );

    protected readonly titleId = `sir-featured-resources-title-${_featuredResourcesUid++}`;
}
